import { Link, Typography } from "@mui/material";

interface Props {
  startYear: number;
  href: string;
  company: string;
}

export default function CopyrightNotice({ startYear, href, company }: Props) {
  const thisYear = new Date().getFullYear();

  const yearRange =
    thisYear === startYear ? thisYear.toString() : `${startYear}-${thisYear}`;

  return (
    <Typography variant="body2" color="text.secondary" align="center">
      Copyright ©{" "}
      <Link color="inherit" href={href} underline="none">
        {company}
      </Link>{" "}
      {yearRange}
    </Typography>
  );
}
